import React from 'react';
import { Alert, Button, Card } from 'antd';
import { PricingAPI } from '../../controller/PricingAPI';

/**
 * 已經登入時開啟邀請連結會走到這裡。
 *
 * 邀請連結的用途是建立新帳號，登入狀態下沒有意義，但直接回 404 會讓人以為
 * 連結壞了 —— 常見情境是管理員自己點開檢查，或受邀者用的是別人登入過的瀏覽器。
 *
 * 登出後 App 會切回未登入分支，而網址不變，同一條連結就會渲染成真正的接受邀請頁。
 */
export default function InviteSignedInNotice() {
    const user = PricingAPI.auth.getLoginUser();

    return (
        <Card title="這是一條邀請連結" style={{ maxWidth: 480, margin: '40px auto' }}>
            <Alert
                type="info"
                showIcon
                message={`你目前以 ${user?.email || '其他帳號'} 登入`}
                description="邀請連結是用來建立新帳號的，需要先登出才能使用。如果這條連結不是給你的，直接關閉此頁即可。"
                style={{ marginBottom: 16 }}
            />
            <Button type="primary" block onClick={() => PricingAPI.auth.logout()}>
                登出並使用這條邀請連結
            </Button>
        </Card>
    );
}
